import $ from '@vaersaagod/tools/Dom';
import Dispatch from '@vaersaagod/tools/Dispatch';
import * as Events from '../lib/events';

export default el => {
    const dom = $(el);
    const header = $('[data-page-header]');
    const expandables = dom.find('[aria-expanded]');
    const triggers = dom.find('[data-trigger]');

    let active = false;
    let lastActive = false;

    const reset = () => {
        expandables.each(node => {
            const exp = $(node);
            exp.attr('aria-expanded', false).attr('aria-label', exp.data('label'));
            exp.next().attr('hidden', '');
        });
        document.removeEventListener('keyup', keyHandler);
        active = false;
        lastActive = false;
    };

    const toggle = expandable => {
        const shouldOpen = expandable.attr('aria-expanded') === 'false';
        reset();

        Dispatch.emit(shouldOpen ? Events.MENU_OPEN : Events.MENU_CLOSE, header);

        if (shouldOpen) {
            expandable.attr('aria-expanded', true).attr('aria-label', expandable.data('close'));
            expandable.next().attr('hidden', null);
            document.addEventListener('keyup', keyHandler);
            active = true;
            lastActive = expandable;
        }
    };

    const keyHandler = e => {
        const key = e.keyCode || e.which;
        if (active && key === 27) {
            if (lastActive.next().contains(document.activeElement)) {
                lastActive.focus();
            }
            reset();
            Dispatch.emit(Events.MENU_CLOSE);
        }
    };

    const init = () => {
        expandables.each(node => {
            const exp = $(node);
            exp.data('label', exp.attr('aria-label'));
        });
        expandables.on('click', e => {
            toggle($(e.triggerTarget));
        });
        triggers.on('click', e => {
            $(e.triggerTarget).next().get(0).click();
        });
        Dispatch.on(Events.MENU_CLOSE, reset);
    };

    const destroy = () => {
        expandables.off('click');
        triggers.off('click');
        document.removeEventListener('keyup', keyHandler);
        Dispatch.off(Events.MENU_CLOSE, reset);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/Menu.js